import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import {
  ActivatedRoute,
  Router,
  RouterModule,
} from "@angular/router";
import { OKTA_AUTH, OktaAuthStateService } from "@okta/okta-angular";
import { OktaAuth } from "@okta/okta-auth-js";
import { Subscription } from "rxjs";
import { environment } from "src/environments/environment";
import { AssetsPath } from "src/static-assets/assets-path";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styles: [],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class AppComponent {
  public assetsPath = AssetsPath;
  private readonly isAuthenticated: boolean = false;
  user: string = "";
  public title = `Chat bots for ${environment.name} University`;
  public userData = {
    name: "no user",
    email: "no user",
  };
  public userEmail: any;
  private readonly routerSubscription: Subscription | null = null;

  constructor(
    public authStateService: OktaAuthStateService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    @Inject(OKTA_AUTH)
    private readonly oktaAuth: OktaAuth,
  ) {}

}
